import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import RequireCustomer from '../layouts/my-account/require-customer';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

const Concerns = lazy(() => import('~/apps/smartsend/components/concerns/Concerns'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const title = t('CONCERNS_PAGE_TITLE', { defaultValue: 'Account Concerns' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.AccountConcerns, showSmartActions: true }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.AccountConcerns
      }
    });
  });

  return (
    <Suspense>
      <RequireCustomer isXs={isXs} silent={true}>
        <Tagged tag="screen-account-concerns">
          <Suspense>
            <Concerns displayType="page" />
          </Suspense>
        </Tagged>
      </RequireCustomer>
    </Suspense>
  );
}

Component.displayName = 'SmartSend: Account Concerns';
